// src/components/SettingsPanel.jsx
import React, { useContext, useState } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
// 1. Importamos el hook 'useUser' en lugar de 'UserContext' y 'useContext'
import { useUser } from '../contexts/UserContext';
import { Link } from 'react-router-dom';
import ColorPickerModal from './ColorPickerModal';

const SettingsRow = ({ label, description, children }) => (
  <div className="settings-row">
    <div className="settings-info">
      <span className="settings-label">{label}</span>
      <span className="settings-description">{description}</span>
    </div>
    <div className="settings-control">
      {children}
    </div>
  </div>
);

const SettingsSection = ({ title, children }) => (
  <div className="settings-section">
    <h4>{title}</h4>
    {children}
  </div>
);

const SettingsPanel = ({ onClose }) => {
  const { theme, toggleTheme, positiveColor, negativeColor, updateStyleColors } = useContext(ThemeContext);
  // 2. Usamos el hook 'useUser'. 'loading' no es estrictamente necesario aquí
  //    si solo queremos prevenir el crash, pero 'userData' SÍ.
  const { userData } = useUser();
  const [whitelistEnabled, setWhitelistEnabled] = useState(false);
  const [isColorModalOpen, setIsColorModalOpen] = useState(false);

  const handleColorSave = (newPositiveColor, newNegativeColor) => {
    updateStyleColors(newPositiveColor, newNegativeColor);
  };

  return (
    <>
      <div className="settings-overlay" onClick={onClose}></div>
      <div className="settings-panel">
        <div className="settings-header">
          <h3>Configuraciones</h3>
          <button onClick={onClose} className="close-btn">&times;</button>
        </div>
        <div className="settings-content">
          <SettingsSection title="Perfil">
            <div className="profile-setting-row">
              <div className="profile-details">
                {/* 3. ¡AQUÍ ESTÁ LA SOLUCIÓN! (Línea 45) */}
                {/* Añadimos '?' (encadenamiento opcional) y una imagen de fallback */}
                <img
                  src={userData?.avatarUrl || '../assets/default-avatar.png'}
                  alt="Avatar de usuario"
                  className="profile-setting-avatar"
                />
                <div className="profile-setting-info">
                  <span className="settings-label">Nombre</span>
                  {/* Añadimos '?' aquí también por seguridad */}
                  <span className="settings-description">{userData?.fullName} {userData?.username}</span>
                </div>
              </div>
              <div className="settings-control">
                <Link to="/perfil" className="action-btn">Editar Perfil</Link>
              </div>
            </div>
          </SettingsSection>

          <SettingsSection title="Preferencias">
            <SettingsRow label="Color de Estilo" description="Verde Arriba / Rojo Abajo">
              <button className="action-btn" onClick={() => setIsColorModalOpen(true)}>Editar</button>
            </SettingsRow>
            <SettingsRow label="Tema" description={theme === 'dark' ? 'Oscuro' : 'Claro'}>
              <label className="switch">
                <input id="settings-theme-toggle" name="theme" type="checkbox" checked={theme === 'dark'} onChange={toggleTheme} />
                <span className="slider round"></span>
              </label>
            </SettingsRow>
          </SettingsSection>

          <SettingsSection title="Seguridad de Retiros">
            <SettingsRow label="Lista Blanca de Retiro" description="Activado / Desactivado">
              <label className="switch">
                <input id="settings-whitelist-toggle" name="whitelist" type="checkbox" checked={whitelistEnabled} onChange={() => setWhitelistEnabled(!whitelistEnabled)} />
                <span className="slider round"></span>
              </label>
            </SettingsRow>
          </SettingsSection>

          <SettingsSection title="Privacidad">
            <SettingsRow label="Descargar Datos Personales" description="Descarga tu perfil, depósitos y retiros.">
              <button className="action-btn">Descargar</button>
            </SettingsRow>
          </SettingsSection>
        </div>
      </div>

      {isColorModalOpen && (
        <ColorPickerModal
          initialPositive={positiveColor}
          initialNegative={negativeColor}
          onSave={handleColorSave}
          onClose={() => setIsColorModalOpen(false)}
        />
      )}
    </>
  );
};

export default SettingsPanel;
